<template>
<div >
<div v-if="page" class="part1">
           <div class="popup-total mt-5 mb-5">
           <div class="left_side">
           <div class="date"> Data Atual </div>
           <div class="mt-3 numero_data_atual"> {{selectedParcela.vencimentoAtual}}</div>
           </div>
            <div class= "arrow fas fa-solid fa-arrow-right ml-5 mr-5 mt-3"></div>
            <div class="right_side">
           <div class="date"> Nova Data </div>
           <div class="mt-3 numero_data_atual"> {{selectedParcela.vencimentoNovo}} </div>
           </div>
        </div>
</div>
<div v-if="!page" class="part2">
                <label class="textinitial mt-3" id="part2-label">Adicione uma Observação</label>
                <textarea v-model="observacao" class="form-control"  id="part2-campo" rows="5"></textarea>
            </div>

            <div class="btn-add">
                <button  v-if="btnRepprove"  v-on:click="repprove" ref="btn_repprove" class="buttonrepprove"> REPROVAR </button>
                <button  v-if="btnApprove" @click="$emit('loadTableAprovar',selectedParcela.id)" v-on:click="approve" ref="btn_approve" class="buttonapprove"> APROVAR </button>
                <button v-if="btnSend" @click="$emit('loadTableReprovar',selectedParcela.id, observacao)" v-on:click="sendrepproved" ref="btn_send" id="btn-adicionar" class="buttonsend"> ENVIAR </button>
          </div>
</div>

</template>

<script>

import approvedisapprove from './approvedisapprove'
export default approvedisapprove

</script>

<style scoped>

.btn-add{
    display: flex;
    justify-content: space-around;
    margin-top: 70px;
}

.botoesPopUp{
    width: 251px;
    height: 41px;
    background: #DEDEDE 0% 0% no-repeat padding-box;
    border-radius: 4px;
    border-style: none;
}
.buttonrepprove{
    width: 190px;
    height: 35px;
    color: #fafafa;
    font-size: 15px;
    font-family:'Segoe UI';
    background: #CC3131 0% 0% no-repeat padding-box;
    border-radius: 4px;
    border-style: none;
}
.buttonapprove{
    width: 190px;
    height: 35px;
    color: #fafafa;
    font-size: 15px;
    font-family:'Segoe UI';
    background: #008148 0% 0% no-repeat padding-box;
    border-radius: 4px;
    border-style: none;
}

.buttonsend{
    width: 221px;
    height: 45px;
    color: #fafafa;
    font-size: 20px;
    font-family:'Segoe UI';
    background: #008148 0% 0% no-repeat padding-box;
    border-radius: 4px;
    border-style: none;
}
.classbuttonclose{
    text-align: right;
}
.buttonclose{
    border-radius: 50%;
    border: none;
    background: #A8A8A8;
    color: white ;
    opacity: 100%;
    width: 25px;
    height: 25px;
}

#part2-label{
    display: block;
    text-align: center;
    padding-bottom: 20px;
    font: normal normal 600 20px/27px Segoe UI;
    letter-spacing: 0px;
    color: #2A2A2A;
    text-transform: uppercase;
}
#part1-label{
    display: block;
    text-align: center;
    font: normal normal 600 20px/27px Segoe UI;
    letter-spacing: 0px;
    color: #2A2A2A;
}

#part2-campo{
    margin-bottom: 10px;
    font:18px;
    font-family: 'Segoe UI';
    /* color: #707070; */
    color: #2A2A2A;
    border-radius: 10px;
    background-color: #fafafa;
}

.date{
    font-size: 20px;
    color: #2A2A2A;
    font-family: 'Segoe UI';
}
.arrow{
    justify-content: space-between;
    text-align: center;
    font-size: 30px;
    color: rgba(204, 194, 194, 0.705)
}
.numero_data_atual{
    color: #008148;
    font-size: 20px;
    font-family: 'Segoe UI';
    font-weight: bold;
}
.popup-total{
    display: flex;
    text-align: center;
    justify-content: center;
}

.btn-add{
    display: flex;
    justify-content: space-around;
    margin-top: 70px;
}

.titlepart1{
    text-align: center;
    font: normal normal 600 15px/27px Segoe UI;
    letter-spacing: 0px;
    color: #2A2A2A;
}

div#modal-approve___BV_modal_body_{
border-radius: 50%;
background: white;
}
div#modal-approve___BV_modal_content_ {
    border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/changedateofinstallment/components/approvedisapprove/approvedisapprove.vue